export default "__VITE_ASSET__sHwN6Rr6__"